import React, { useState } from 'react';
import SectionHeading from '../UI/SectionHeading';
import './DemoSection.css';

interface DemoStep {
  id: number;
  shortTitle: string;
  title: string;
  description: string;
  image: string;
}

const DemoSection: React.FC = () => {
  const [activeStep, setActiveStep] = useState<number>(1);
  
  const demoSteps: DemoStep[] = [
    {
      id: 1,
      shortTitle: 'Этап 1',
      title: 'Установка габаритов здания',
      description: 'На этом этапе архитектор задает параметры проектирования: габариты здания, количество квартир разного типа, их желаемое количество и размеры. KVADRO анализирует введенные данные и готовит базу для генерации вариантов планировок.',
      image: '/stage_1.gif'
    },
    {
      id: 2,
      shortTitle: 'Этап 2',
      title: 'Добавление межквартирных коридоров',
      description: 'На этом этапе архитектор указывает расположение межквартирных коридоров.',
      image: '/stage_2.gif'
    },
    {
      id: 3,
      shortTitle: 'Этап 3',
      title: 'Автоматическое формирование "пятен" и комнат внутри',
      description: 'Алгоритмы KVADRO автоматически формируют оптимальные "пятна" квартир на основе технического задания и формы здания. Этот этап обычно занимает 2 месяца при традиционном подходе, но с KVADRO выполняется за несколько секунд.',
      image: '/stage_3.gif'
    },
    {
      id: 4,
      shortTitle: 'Этап 4',
      title: 'Добавление лифтов и лестниц',
      description: 'На этом этапе архитектор расставляет лифты и лестницы.',
      image: '/stage_4.gif'
    },
    {
      id: 5,
      shortTitle: 'Этап 5',
      title: 'Возведение межкомнатных перегородок',
      description: 'На этом этапе KVADRO автоматически располагает межкомнатные перегородки.',
      image: '/stage_5_1.gif'
    },
    {
      id: 6,
      shortTitle: 'Этап 6',
      title: 'Возможность бесконечных регенераций',
      description: 'Архитектор имеет возможность бесконечных регенераций, что позволяет ему получить подходящие варианты планировок.',
      image: '/stage_6.gif'
    }
  ];
  
  const currentStep = demoSteps.find(step => step.id === activeStep) || demoSteps[0];

  return (
    <section id="demo" className="demo-section section">
      <div className="container">
        <SectionHeading 
          title="Демонстрация работы KVADRO"
          subtitle="Процесс создания объемно-планировочных решений"
        />
        
        {/* Circle navigation for mobile */}
        <div className="demo-steps-circles">
  {demoSteps.map(step => (
    <button
      key={`circle-${step.id}`}
      className={`demo-step-circle ${step.id === activeStep ? 'active' : ''}`}
      onClick={() => setActiveStep(step.id)}
      aria-label={`Перейти к ${step.shortTitle}`}
    >
      <span className="step-label">Этап</span> {step.id}
    </button>
  ))}
</div>
        
        <div className="demo-container">
          {/* Desktop sidebar navigation */}
          <div className="demo-steps desktop-only">
            {demoSteps.map(step => (
              <div 
                key={step.id}
                className={`demo-step ${step.id === activeStep ? 'active' : ''}`}
                onClick={() => setActiveStep(step.id)}
              >
                <h4 className="step-title">{step.shortTitle}</h4>
                <p className="step-description">{step.title}</p>
              </div>
            ))}
          </div>
          
          {/* Content box with image */}
          <div className="demo-content">
          <div className="demo-result">
  <div className="demo-text-content">
    <h3 className="demo-title">{currentStep.title}</h3>
    <p className="demo-description">{currentStep.description}</p>
  </div>
  <img 
    src={currentStep.image || '/demo-placeholder.png'} 
    alt={`Демонстрация ${currentStep.shortTitle}`} 
    className="demo-image" 
  />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoSection;